/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorLocationModel } from '../../models/patient-behavior-location-model';

export interface GetPatientBehaviorLocations$Params {
  onlyActive?: boolean;
}

export function GetPatientBehaviorLocations(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorLocationModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorLocations.PATH, 'get');
  if (params) {
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorLocationModel>>;
    })
  );
}

GetPatientBehaviorLocations.PATH = '/api/Staff/GetPatientBehaviorLocations';
